import { render } from "./EvidenceTableInput.vue?vue&type=template&id=14098882"
import script from "./EvidenceTableInput.vue?vue&type=script&lang=js"
export * from "./EvidenceTableInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__